import React, { Fragment } from 'react';

import { PageTitle } from '../../layout-components';
import CompanyKPI from '../../flowtrace-components/CompanyKPI';

const explanation = []
explanation.push(<h4 key="header" className="heading-2 pb-1">Company KPIs</h4>)
explanation.push(<p key="paragraph1">Flowtrace tracked KPIs.</p>)

export default function CompanyKPIDashboard(props) {
  return (
    <Fragment>
      <PageTitle key="title" titleHeading="Flowtrace Dashboard" titleDescription="Here you can see all Flowtrace connected analytics KPI's" explanation={explanation}/>
      <CompanyKPI flowtraceUser={props.flowtraceUser}/>
    </Fragment>
  );
}
